module.exports = __webpack_public_path__ + "static/img/banner-logo.9eb02ac.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Telll/banner-logo.svg
// module id = +wJJ
// module chunks = 0